import { autocomplete } from '@algolia/autocomplete-js';
import { Client  } from 'typesense';

$(document).ready(function () {
    let typesenseClient = new Client({
        'nearestNode': {'host': TYPESENSE_HOST, 'port': TYPESENSE_PORT, 'protocol': 'https'},
        'nodes': [
            {'host': TYPESENSE_HOST, 'port': TYPESENSE_PORT, 'protocol': 'https'},
        ],
        'apiKey': TYPESENSE_API_KEY_PUBLIC,
        'connectionTimeoutSeconds': 2
    })

    // On the results page the box keeps the searched term (the category stays selected through
    // #search-scope in common/header.tpl). Read from the URL so no theme template has to inject it.
    const pageParams = new URLSearchParams(window.location.search);
    const initialQuery = pageParams.get('route') === 'product/search' ? (pageParams.get('search') || '') : '';

    autocomplete({
        container: '#algolia-search',
        placeholder: 'Cine caută, găsește!',
        openOnFocus: true,
        initialState: {query: initialQuery},
        async getSources({query}) {
            const results = await typesenseClient.collections(ESI_SEARCH_SUGGESTIONS).documents().search({
                q: query,
                filter_by: 'store_id: [' + CURRENT_STORE_ID + ']',
                preset: ESI_SEARCH_SUGGESTIONS,
                highlight_full_fields: 'query',
                include_fields: 'query'
            })

            return [
                {
                    sourceId: 'predictions',
                    getItems() {
                        return results.hits;
                    },
                    getItemInputValue({item}) {
                        return item.document.query;
                    },
                    templates: {
                        item({ item, html }) {
                            // html is from the `htm` package. Docs: https://github.com/developit/htm

                            // Get the highlighted HTML fragment from Typesense results
                            //const html_fragment = html`${item.highlights.find(h => h.field === 'query' || {}).value || item.document['query']}`

                            // Send the html_fragment to `html` tagged template
                            // Reference: https://github.com/developit/htm/issues/226#issuecomment-1205526098
                            //return html`<div dangerouslySetInnerHTML=${{ __html: html_fragment }}></div>`

                            // window.SEARCH_URL is injected by common/header.tpl and already
                            // carries the active language prefix.
                            const searchUrl = (window.SEARCH_URL || './index.php?route=product/search') + '&search=' + encodeURIComponent(item.document['query']);
                            return html`<a class="aa-ItemLink" href="${searchUrl}" dangerouslySetInnerHTML=${{ __html: item.document['query'] }}></a>`;
                        },
                    },
                },
            ];
        },
        onSubmit(event) {
            const base = window.SEARCH_URL || './index.php?route=product/search';
            location = base + '&search=' + encodeURIComponent(event.state.query);
        }
    });

    // In the detached (mobile) layout the library renders no <label>, so the combobox's
    // aria-labelledby points at nothing and screen readers announce an unnamed field.
    document.querySelectorAll('#algolia-search .aa-Autocomplete').forEach((el) => {
        el.setAttribute('aria-label', 'Caută produse');
    });

});
